module.exports = __webpack_public_path__ + "static/media/my_project_pin.3341113c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Shared/Sidebar/my_project_pin.svg
// module id = 1425
// module chunks = 2